import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import MuiSwitch from '@mui/material/Switch';

const CustomSwitch = styled(MuiSwitch)(({ theme, size }) => ({
  width: size === 'small' ? 38 : 42,
  height: size === 'small' ? 20 : 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: size === 'small' ? 1.5 : 2,
    margin: size === 'small' ? 1 : 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        border: 0,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: size === 'small' ? 16 : 19,
    height: size === 'small' ? 16 : 19,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: '#5A5A5A',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

export default function StyledSwitch({
  id = '',
  disabled = false,
  label = '',
  checked = false,
  labelPlacement = 'end',
  size = 'medium',
  sx = {},
  onChange = () => {},
  onClick = () => {},
  ...formControlLabelProps
}) {
  return (
    <FormControlLabel
      id={id}
      labelPlacement={labelPlacement}
      disabled={disabled}
      sx={{
        display: 'flex',
        alignItems: 'center',
        m: 0,
        ...sx,
      }}
      label={label}
      {...formControlLabelProps}
      control={
        <CustomSwitch
          checked={checked}
          onChange={onChange}
          onClick={onClick}
          sx={labelPlacement === 'start' ? { ml: '12px' } : { mr: '12px' }}
          size={size}
        />
      }
    />
  );
}

StyledSwitch.propTypes = {
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  labelPlacement: PropTypes.oneOf(['start', 'bottom', 'top', 'end']),
  size: PropTypes.oneOf(['small', 'medium']),
  sx: PropTypes.object,
};
